export const breakpoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};

export function resolveResponsiveValue(value, width) {
  if (typeof value !== 'object' || value === null) return value;
  if (width == null) return value.base;
  const match = Object.keys(value)
    .filter(key => key !== 'base' && breakpoints[key] >= width)
    .sort((a, b) => breakpoints[a] - breakpoints[b])[0];
  return match === undefined ? value.base : value[match];
}
